import { languages } from './../demo/constants/languages';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AppSidebarComponent } from './app.sidebar.component';
import { Router } from '@angular/router';
import { CartService } from '../demo/service/cart.service';
import { PeekCart } from '../demo/models/peek-cart';
import { QuotationActionsService } from '../demo/actions/quotation-actions.service';
import { Subscription, filter } from 'rxjs';
import { LanguageService } from '../demo/service/language.service';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../demo/service/auth.service';
import { ScreenSizeService } from '../demo/service/screen-size.service';
import { CustomToastrService } from '../demo/service/custom-toastr.service';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
})
export class AppTopbarComponent implements OnInit {
    quoteSubscription!: Subscription;
    peekCartObject!: PeekCart;
    userProfile!: any;
    languages: any = languages;
    selectedLanguage!: any;

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;

    constructor(
        public layoutService: LayoutService,
        private screenSizeService: ScreenSizeService,
        private translate: TranslateService,
        private languageService: LanguageService,
        private quoteActions: QuotationActionsService,
        public el: ElementRef,
        private wiseToastr: CustomToastrService,
        private router: Router,
        private messageService: MessageService,
        private authToken: AuthService,
        private cartService: CartService
    ) {}

    ngOnInit(): void {
        this.peekCart();
        this.fetchUserProfile();
        this.onNewItemAddedToCart();
        this.onSuccessfulCheckout();
        this.initializeLocale();
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            if (language === 'en') {
                this.selectedLanguage = languages[0]['value'];
            }
            if (language === 'pt') {
                this.selectedLanguage = languages[1]['value'];
            }
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }

    getDeviceType(): string {
        return this.screenSizeService.getDeviceType();
    }

    languageChanged(event: DropdownChangeEvent) {
        this.setLanguage(event.value);
    }

    onNewItemAddedToCart() {
        this.quoteSubscription = this.quoteActions.click$.subscribe(() => {
            this.peekCart();
        });
    }

    onSuccessfulCheckout() {
        this.quoteSubscription = this.quoteActions.cartCheckoutClick$.subscribe(
            () => {
                this.peekCart();
            }
        );
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    fetchUserProfile() {
        this.userProfile = this.authToken.getProfile();
    }

    peekCart() {
        this.cartService.peekCart().subscribe({
            next: (value) => {
                this.peekCartObject = value;
            },
            error: (err) => {
                this.wiseToastr.showError(this.translate.instant(err.error.messageKey))
            },
        });
    }

    onProfileButtonClick() {
        this.layoutService.showRightMenu();
    }

    onSearchClick() {
        this.layoutService.toggleSearchBar();
    }

    onRightMenuClick() {
        this.layoutService.showRightMenu();
    }

    onLogout() {
        this.authToken.logout();
        this.router.navigate(['/']);
        this.wiseToastr.showSuccess('Logout successful');
    }

    get logo() {
        const logo =
            this.layoutService.config().menuTheme === 'white' ||
            this.layoutService.config().menuTheme === 'orange'
                ? 'dark'
                : 'white';
        return logo;
    }

    ngOnDestroy() {
        this.quoteSubscription.unsubscribe();
    }
}
